<template>  
  <div class="orderdelivery">
    <XR-head titleText="物流追踪"></XR-head>
    <template v-for="trackingItem in deliveryTracking">
      <div class="delivery-info" v-if="!loaded">
        <div class="field">{{trackingItem.LogisticsCompanyIdName}}</div>
        <div class="field">运单号：{{trackingItem.DeliveryNo}}</div>
      </div>
      <div class="delivery-process" v-if="!loaded">
        <mu-timeline>
          <template v-for="(wuliuItem,index) in trackingItem.WuLiu.data">      
            <mu-timeline-item :iconColor="index ==0 ? 'red' : '#aaa'">
              <span slot="time" :class="index ==0 ?'delivery-time new' : 'delivery-time'">{{wuliuItem.time}}</span>
              <span slot="des" :class="index ==0 ?'delivery-desc new' : 'delivery-desc'">{{wuliuItem.context}}</span>
            </mu-timeline-item>
          </template>
        </mu-timeline>
      </div>
    </template>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fullWidth:document.documentElement.clientWidth,
      suborderItemProductNameWidth: (parseInt(document.documentElement.clientWidth)-90),
      deliveryTracking:[],
      loaded:true
    }
  },
  mounted(){
    this.$refs.XRtoast.load()
    this.getDeliveryTracking()
  },
  methods: {
    getDeliveryTracking(){           
      var ths = this;   
      ths.$post(
        "/Shop/IntegralServer/GetIntegralOrderDelivery",
        JSON.stringify({orderNo:this.$route.query.orderNo})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded =false
          ths.deliveryTracking = res.Data
          ths.$refs.XRtoast.hide()
        }
      });
    }
  }
}
</script>

<style>
.orderdelivery .delivery-info{
  background: white;
  padding:10px;
}
.orderdelivery .delivery-info .field {
  margin-top:10px;
  background: white;
  line-height: 16px;
  font-size: 12px;
}

.orderdelivery .delivery-process{
  margin-top:10px;
  background: white;
  padding: 20px;
}
.orderdelivery .delivery-time{
  font-size: 14px;
  color:#aaa;
}
.orderdelivery .delivery-time.new{
  color:red;
}
.orderdelivery .delivery-desc{
  display: block;
  font-size: 12px;
  width: 90%;
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  color:#aaa;
}
.orderdelivery .delivery-desc.new{
  color:red;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/integralOrderdelivery.vue